import { SET_DATA_ALERTS } from './actiontypes';
import {
  fetchDataAlerts,
  createDataAlert,
  updateDataAlert,
  removeAlert,
  createDataAlertAction,
  updateDataAlertAction,
  removeDataAlertAction,
} from '../../api/Api';

// only the fields defiend on NewBuildingAlert are user-writable
const ALERT_WRITABLE_FIELDS = [
  'name',
  'buildings',
  'minutes_stale',
  'point_threshold',
  'percent_threshold',
];
// same for actions and NewAlertAction
const ACTION_WRITABLE_FIELDS = ['type', 'params', 'fire_state', 'interval', 'enabled'];

const fields = (fieldNames) => (dataObj) =>
  fieldNames.reduce((o, f) => {
    // eslint-disable-next-line no-param-reassign
    o[f] = dataObj[f];
    return o;
  }, {});

const alertFields = fields(ALERT_WRITABLE_FIELDS);
const actionFields = fields(ACTION_WRITABLE_FIELDS);

export const fetchDataAlertsAction = () => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return fetchDataAlerts(jwt).then((data) => dispatch({ type: SET_DATA_ALERTS, data }));
};

export const createAlertAC = (alert) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return createDataAlert(jwt, alertFields(alert)).then(() => dispatch(fetchDataAlertsAction()));
};

export const updateAlertAC = (alertId, alert) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return updateDataAlert(jwt, alertId, alertFields(alert)).then(() =>
    dispatch(fetchDataAlertsAction())
  );
};

export const removeAlertAC = (alertId) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return removeAlert(jwt, alertId).then(() => dispatch(fetchDataAlertsAction()));
};

export const createAlertActionAC = (alertId, action) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return createDataAlertAction(jwt, alertId, actionFields(action)).then(() =>
    dispatch(fetchDataAlertsAction())
  );
};

export const updateAlertActionAC = (alertId, actionId, action) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return updateDataAlertAction(jwt, alertId, actionId, actionFields(action)).then(() =>
    dispatch(fetchDataAlertsAction())
  );
};

export const removeAlertActionAC = (alertId, actionId) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return removeDataAlertAction(jwt, alertId, actionId).then(() =>
    dispatch(fetchDataAlertsAction())
  );
};
